import "./App.css";
import { Outlet } from "react-router";
import { useUrlQuery } from "./utils/hooks/use-url-query";
import { useEffect } from "react";
import { addRecentLoginData } from "./store/modules/app-state/app-state.actions";
import { SDKConfig } from "./@sdk/default-sdk-config";
import { AccountsAndUserManagementServices } from "./@sdk/user-management/user-management.service";
import { useDispatch } from "react-redux";
import { setSwitchingProfile } from "./store/modules/app-state/app-state.actions";
import { setAccessToken } from "./store/modules/users/users.actions";
import { logout } from "./store/modules/users/users.actions";
import { BrowserHistory } from "./store/browser-history";

function App() {
  const urlQuery = useUrlQuery();
  const dispatch = useDispatch();
  const accessTokenInUrl = urlQuery.get("accessToken")!;
  useEffect(() => {
    if (accessTokenInUrl) {
      const newUserSDK = new AccountsAndUserManagementServices({
        ...SDKConfig,
        token: accessTokenInUrl,
      });
      dispatch(setSwitchingProfile(true));
      Promise.all([
        newUserSDK.getCurrentUser(),
        newUserSDK.getCurrentOrganization(),
      ]).then(([user, organization]) => {
        dispatch(
          addRecentLoginData({
            // Org Data
            domain: organization.domain.toLowerCase(),
            // organizationLogo: string,
            // User Data
            email: user.credentials.email.toLowerCase(),
            firstName: user.data.firstName,
            lastName: user.data.lastName,
            avatar: user.data.avatar,
            // Access Data
            accessToken: accessTokenInUrl,
          })
        );
        dispatch(logout());
        urlQuery.delete("accessToken");
        BrowserHistory.replace({ search: urlQuery.toString() });
        setTimeout(() => {
          dispatch(setAccessToken(accessTokenInUrl));
          dispatch(setSwitchingProfile(false));
        }, 100);
      });
    }
  }, [accessTokenInUrl, dispatch, urlQuery]);
  return (
    <>
      <Outlet />
    </>
  );
}

export default App;
